import { useEffect, useRef, useState } from "react";
import ImageGallery from "../ImageGallery/ImageGallery";
import Breadcrumb from "../breadcrumb/breadcrumb";
import SEO from "../SEO/SEO";
import { trackPhoneClick, trackAirbnbClick } from "../../utils/analytics";
import "./appartment407.css";

// Import de toutes les images
import img1 from "../../assets/img407/20250306_112353.avif";
import img2 from "../../assets/img407/20250306_112315.avif";
import img3 from "../../assets/img407/20250306_112252.avif";
import img4 from "../../assets/img407/20250306_112421.avif";
import img5 from "../../assets/img407/Cuisine407-5.avif";
import img6 from "../../assets/img407/GDHOTEL-1.avif";
import img7 from "../../assets/img407/SDbain-1.avif";
import img8 from "../../assets/img407/Vuedu407jour.avif";

export default function Appartment407() {
  const airbnbRef = useRef(null);
  const [isAirbnbVisible, setIsAirbnbVisible] = useState(false);

  const images = [
    { src: img1, alt: "Appartement 407 - Vue 1" },
    { src: img2, alt: "Appartement 407 - Vue 2" },
    { src: img3, alt: "Appartement 407 - Vue 3" },
    { src: img4, alt: "Appartement 407 - Vue 4" },
    { src: img5, alt: "Cuisine 407" },
    { src: img6, alt: "Grand Hôtel" },
    { src: img7, alt: "Salle de bain" },
    { src: img8, alt: "Vue du 407" },
  ];

  useEffect(() => {
    // Lazy loading du widget Airbnb - charge seulement quand visible
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isAirbnbVisible) {
            setIsAirbnbVisible(true);
          }
        });
      },
      { rootMargin: "100px" }, // Charge 100px avant que l'élément soit visible
    );

    const currentRef = airbnbRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [isAirbnbVisible]);

  useEffect(() => {
    // Charger le script Airbnb seulement si visible
    if (isAirbnbVisible && airbnbRef.current) {
      const script = document.createElement("script");
      script.src = "https://www.airbnb.fr/embeddable/airbnb_jssdk";
      script.async = true;
      airbnbRef.current.appendChild(script);
    }
  }, [isAirbnbVisible]);

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Apartment",
    name: "Appartement 407 - Location 4 Étoiles",
    description:
      "Appartement lumineux de 38m² classé 4 étoiles avec balcon et vue sur le parc thermal, idéal pour cure thermale à Châtel-Guyon",
    floorSize: {
      "@type": "QuantitativeValue",
      value: 38,
      unitCode: "MTK",
    },
    numberOfRooms: 1,
    occupancy: {
      "@type": "QuantitativeValue",
      minValue: 1,
      maxValue: 2,
    },
    starRating: {
      "@type": "Rating",
      ratingValue: "4",
    },
    address: {
      "@type": "PostalAddress",
      streetAddress: "3 Place Brosson",
      addressLocality: "Châtel-Guyon",
      postalCode: "63140",
      addressCountry: "FR",
    },
    offers: {
      "@type": "Offer",
      price: "800",
      priceCurrency: "EUR",
      description: "Tarif pour 3 semaines de cure thermale",
      availability: "https://schema.org/InStock",
    },
    amenityFeature: [
      { "@type": "LocationFeatureSpecification", name: "Balcon" },
      { "@type": "LocationFeatureSpecification", name: "Parking privé" },
      { "@type": "LocationFeatureSpecification", name: "Cuisine équipée" },
      { "@type": "LocationFeatureSpecification", name: "Lave-linge" },
      { "@type": "LocationFeatureSpecification", name: "Lave-vaisselle" },
      { "@type": "LocationFeatureSpecification", name: "TV 75 pouces" },
      { "@type": "LocationFeatureSpecification", name: "Wifi" },
      { "@type": "LocationFeatureSpecification", name: "Ascenseur" },
    ],
  };

  return (
    <main>
      <SEO
        title="Appartement 407 - Location 4 Étoiles Châtel-Guyon | 38m² Cure Thermale"
        description="Appartement 4 étoiles de 38m² à Châtel-Guyon avec balcon, vue parc thermal, parking privé. Idéal cure thermale, à 3min des Thermes Aïga. Dès 800€ les 3 semaines. ☎ 06 95 39 85 19"
        canonical="https://chatel-guyon-hotel-cure-thermes.fr/appartement-407-4-etoiles-chatel-guyon"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <h1 className="visually-hidden">
        Appartement 407 - Location 4 Étoiles Châtel-Guyon
      </h1>
      <Breadcrumb
        items={[{ label: "Accueil", url: "/" }, { label: "Appartement 407" }]}
      />
      <div id="std-container">
        <div className="stdleft">
          <div
            id="carousel407"
            role="region"
            aria-label="Galerie d'images de l'Appartement 407"
          >
            <ImageGallery images={images} />
          </div>
        </div>
        <div className="stdright">
          <iframe
            src="https://www.bookingmood.com/airbnb-embed?language=fr-FR&listing=570227229585085704&theme=Elegant"
            className="iframe-calendar"
            title="Calendrier des disponibilités Appartement 407"
          ></iframe>
          <hr className="section-divider-small" />
          <h2 className="centertext">
            Réservation au{" "}
            <a
              href="tel:+33695398519"
              onClick={() => trackPhoneClick("appartment_page")}
            >
              06 95 39 85 19
            </a>
          </h2>
          <hr className="section-divider-top-only" />
          <div className="pricing-options407">
            <h3>Nos formules :</h3>
            <ul>
              <li>Trois semaines de 800.00€ à 850.00€ (Cure)</li>
              <li>Semaine de 320.00€ à 350.00€</li>
              <li>Week-end de 150.00€ à 170.00€</li>
              <li>Taxe de séjour 1.10€ (Prix par nuitée/personne)</li>
            </ul>
            <h3>Nos options :</h3>
            <ul>
              <li>
                Supplément animaux journalier à 3.00€ (Forfait : 20 euros la
                cure)
              </li>
              <li>Ménage de fin de cure 50.00€</li>
              <li>Linge de toilette 15.00€</li>
              <li>Linge de lit 15.00€</li>
            </ul>
          </div>
        </div>
      </div>
      <hr className="section-divider" />
      <div className="box-stack">
        <div className="box-info">
          <p>
            Cet appartement lumineux de 37&nbsp;m² classé 4 étoiles, situé à
            l’avant-dernier étage et accessible par ascenseur, il dispose d'un
            balcon offrant une vue imprenable sur le parc et la place du
            Théâtre, ainsi que d’un parking privé sur demande. <br />
            L’appartement est entièrement équipé pour votre confort: cuisine
            moderne, lave-linge, TV grand écran, et de nombreux rangements.
            Idéal pour un séjour thermal ou touristique, il allie calme,
            luminosité et proximité immédiate des Thermes et des commerces.
            <br />
            Merci de signaler la présence d'animaux lors de la réservation.
          </p>
        </div>
        <hr className="section-divider-small" />

        <h2 className="centertext">Equipements</h2>

        <div className="box-info">
          <div className="equipment">
            <div className="centerequipment">
              <h3>Chambre et linge</h3>
              <ul>
                <li>Lave-linge</li>
                <li>Sèche-linge</li>
                <li>Étendoir à linge</li>
                <li>Équipements de base (Serviettes et draps)</li>
                <li>Cintres</li>
                <li>Oreillers et couvertures supplémentaires</li>
                <li>Stores</li>
                <li>Fer à repasser</li>
                <li>Espace de rangement pour les vêtements</li>
                <li>TV HD 75 pouces avec abonnement standard au câble</li>
              </ul>
            </div>
            <div className="centerequipment">
              <h3>Salle de bain</h3>
              <ul>
                <li>Sèche-cheveux</li>
                <li>Sèche-serviette</li>
              </ul>
            </div>

            <div className="centerequipment">
              <h3>Cuisine et salle à manger</h3>
              <ul>
                <li>Réfrigérateur</li>
                <li>Congélateur</li>
                <li>Vaisselle et couverts</li>
                <li>Lave-vaisselle</li>
                <li>Plaques de cuisson</li>
                <li>Four</li>
                <li>Bouilloire électrique</li>
                <li>Micro-ondes</li>
                <li>Grille-pain</li>
                <li>Cafetière</li>
              </ul>
            </div>
            <div className="centerequipment">
              <h3>Autres</h3>
              <ul>
                <li>Chauffage électrique</li>
                <li>Wifi</li>
                <li>Ascenseur</li>
                <li>Balcon</li>
                <li>Parking public à proximité</li>
                <li>Dépôt de bagages autorisé</li>
                <li>Clés remises par l'hôte</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="box-info"></div>
      </div>
      <hr className="section-divider" />
      <h2 className="centertext">Disponible également sur Airbnb</h2>
      <div
        className="airbnb-embed-frame airbnb-embed-container"
        data-id="570227229585085704"
        data-view="home"
        data-hide-price="true"
        ref={airbnbRef}
        title="Appartement 407 sur Airbnb"
      >
        <a
          href="https://www.airbnb.fr/rooms/570227229585085704?check_in=2026-03-01&amp;check_out=2026-03-06&amp;guests=1&amp;adults=2&amp;s=66&amp;source=embed_widget"
          onClick={() => trackAirbnbClick("appartment407")}
        >
          Voir sur Airbnb
        </a>
        <a
          href="https://www.airbnb.fr/rooms/570227229585085704?check_in=2026-03-01&amp;check_out=2026-03-06&amp;guests=1&amp;adults=2&amp;s=66&amp;source=embed_widget"
          rel="nofollow"
          onClick={() => trackAirbnbClick("appartment407")}
        >
          Appartement en résidence · Châtel-Guyon · 1 chambre · 1 lit ·
          1&nbsp;salle de bain
        </a>
        {/* Le script Airbnb sera injecté ici */}
      </div>
    </main>
  );
}
